import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import DocumentArrowUpSvg from '@/assets/DocumentArrowUp.svg';

const DocumentArrowUp = ({ size, variant, className }: IconProps) => (
  <img
    src={DocumentArrowUpSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default DocumentArrowUp;
